/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';

export const snackBarSX: SxProps<Theme> = {
	maxWidth: '100%',
	p: 2,
	zIndex: 10000,
	'@media (max-width: 600px)': {
		'&.MuiSnackbar-anchorOriginBottomCenter, &.MuiSnackbar-anchorOriginBottomLeft, &.MuiSnackbar-anchorOriginBottomRight':
			{
				bottom: {
					xs: 'max(env(safe-area-inset-bottom), 0px) !important',
					md: '0 !important',
				},
				pb: { xs: 0.5, md: 2 },
			},
	},
};
